import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';

const formatDuration = (value = 0) => {
  const seconds = Math.max(0, Number(value) || 0);
  return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
};

export default function PendingUsers({ onDecision, onCountChange, busy, propertyEngagement = [] }) {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!db || !auth?.currentUser) {
      setError('Sign in with an authorized admin account to view pending users.');
      return undefined;
    }
    const pendingQuery = query(collection(db, 'users'), where('approvalStatus', '==', 'pending'));
    return onSnapshot(pendingQuery, (snapshot) => {
      const rows = snapshot.docs.map((item) => ({ id: item.id, ...item.data() }));
      setUsers(rows);
      onCountChange?.(rows.length);
      setError('');
    }, () => setError('Could not load pending users. Check admin permissions and Firestore rules.'));
  }, [onCountChange]);

  const propertyPages = propertyEngagement.filter((item) => /^\/properties\/[^/]+/.test(item.path || ''));

  return <div className="pending-users-panel" aria-live="polite">
    {error && <p className="form-error" role="alert">{error}</p>}
    <div className="property-admin-title"><div><p className="eyebrow">ACCOUNT MODERATION</p><h3>Pending user requests</h3><p className="muted-copy">Elevated account requests appear here as soon as they are submitted.</p></div><span>{users.length} awaiting review</span></div>
    <div className="admin-submission-list">{users.length ? users.map((row) => <article key={row.id}>
      <div><span className="demo-badge">PENDING APPROVAL</span><h3>{row.fullName || row.email || 'New user'}</h3><p>{row.email || 'No email'} · {row.mobile || 'No phone number'} · Requested: {row.requestedRole || 'user'}</p></div>
      <div className="property-review-actions"><button className="primary-action" disabled={busy} onClick={() => onDecision(row, 'approved')}>Approve</button><button className="secondary-action" disabled={busy} onClick={() => onDecision(row, 'rejected')}>Decline</button></div>
    </article>) : !error && <p className="muted-copy">No user requests waiting for approval.</p>}</div>

    <div className="pending-user-engagement"><div className="property-admin-title"><div><p className="eyebrow">PROPERTY ENGAGEMENT</p><h3>Visitor time & scroll depth</h3><p className="muted-copy">Aggregated per property page; individual visitors are not identified.</p></div></div>
      <div className="admin-submission-list">{propertyPages.length ? propertyPages.map((page) => <article key={page.path}><div><h3>{page.path.split('/').filter(Boolean).slice(-1)[0]?.replace(/-/g, ' ') || 'Property'}</h3><p>{page.views || 0} visits · Average time {formatDuration(page.averageSeconds)}</p></div><div className="property-review-actions"><span className="demo-badge">Total {formatDuration(page.durationSeconds)}</span><span className="demo-badge">Max scroll {Math.round(page.maxScrollPercent || 0)}%</span></div></article>) : <p className="muted-copy">Property time and scroll data will appear as visitors browse property pages.</p>}</div>
    </div>
  </div>;
}
